import { Option } from '@inrev/core';
import { ExtractionStatus } from '../enums.mjs';

const WIP_EXTRACTED_STATUSES = [
    ExtractionStatus.Completed,
    ExtractionStatus.Partial,
];
function isWipExtractionFinished(extraction) {
    return WIP_EXTRACTED_STATUSES.some((status) => status === extraction.status);
}
function isWipExtractionVerifiedAndComplete(extraction) {
    return (extraction.extractionConfidence === "VERIFIED" &&
        extraction.status === ExtractionStatus.Completed);
}
function isWipExtractionPromotable(extraction) {
    return (isWipExtractionFinished(extraction) &&
        (Option.isSome(extraction.underwriterReviewedAt) ||
            isWipExtractionVerifiedAndComplete(extraction)));
}

export { WIP_EXTRACTED_STATUSES, isWipExtractionFinished, isWipExtractionPromotable, isWipExtractionVerifiedAndComplete };
